module.exports = __webpack_public_path__ + "img/trsd_yl_ico.9d403e38.png";